export default function getPMSLogo(pms) {
  try {
    return require(`assets/images/pms/${pms.toLowerCase()}.png`);
  } catch (error) {
    console.log("Can't find pms image for PMS: ", pms);
    return require(`assets/images/pms/civitfun.png`);
  }
}
